import React from 'react'
import { IconButton } from 'components'

interface ChartPaginationControlsProps {
    currentPage: number
    totalPages: number
    totalItems: number
    showPagination: boolean
    onPrevPage: () => void
    onNextPage: () => void
    onGoToPage?: (pageNumber: number) => void
}

export function ChartPaginationControls(props: ChartPaginationControlsProps) {
    const {
        currentPage,
        totalPages,
        totalItems,
        showPagination,
        onPrevPage,
        onNextPage,
        onGoToPage
    } = props

    if (!showPagination || totalPages <= 1) return null

    const isFirstPage = currentPage <= 1
    const isLastPage = currentPage >= totalPages

    return (
        <div className="chart-pagination-controls">
            <IconButton
                icon="fas fa-chevron-left"
                onClick={onPrevPage}
                disabled={isFirstPage}
                noBg
                alt
            />
            <span>
                Page {currentPage} of {totalPages}
            </span>
            <IconButton
                icon="fas fa-chevron-right"
                onClick={onNextPage}
                disabled={isLastPage}
                noBg
                alt
            />
        </div>
    )
}